// removed by extract-text-webpack-plugin
module.exports = {"conflictDateSpan":"G647366","line":"G00bf2d","modalBody":"G246208","modalCloseButton":"G1c4eb6","modalCloseIcon":"Gea96a3","recipeList":"Ge3b422","recipeListItem":"G517e99"};